import * as GLOBAL from "../data/global.js";

export default class UserServices {

    static getUsers() {
        return fetch(`${global.SERVER_ADDRESS}/user`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static getUser(username) {
        return fetch(`${global.SERVER_ADDRESS}/user/${username}`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static addUser(user) {
        return fetch(`${global.SERVER_ADDRESS}/user`, {
            method: 'POST',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateUser(user) {
        return fetch(`${global.SERVER_ADDRESS}/user/${user.username}`, {
            method: 'PUT',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateUserRole(user) {
        return fetch(`${global.SERVER_ADDRESS}/user/${user.username}/change-role`, {
            method: 'PUT',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateUserPassword(user) {
        return fetch(`${global.SERVER_ADDRESS}/user/${user.username}/change-password`, {
            method: 'PUT',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static ForgetPassword(user) {
        return fetch(`${global.SERVER_ADDRESS}/forget-password/store`, {
            method: 'POST',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static ResetPassword(user) {
        return fetch(`${global.SERVER_ADDRESS}/reset-password/${user.token}`, {
            method: 'POST',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static deleteUser(user) {
        return fetch(`${global.SERVER_ADDRESS}/user/${user.username}`, {
            method: 'DELETE',
            body: JSON.stringify(user),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static Login(username, password) {
        return fetch(`${global.SERVER_ADDRESS}/login`, {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static Logout(id) {
        return fetch(`${global.SERVER_ADDRESS}/logout/${id}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static handleError(error) {
        console.log(error);
    }


}